<template>
    <div >
        <div class="menu_top padding_bottom_64">
            <div class="cart_suggesttitle margin_top_32 display_flex  justify-content_flex-justify"><span>{{this.$route.query.type=='Alipay'?payorder.Alipay:payorder.WeChat}} {{$t('order.desc1')}}</span></div>
            <div class="paybox" v-bind:class="{ active: this.$route.query.type=='Alipay' }">
                <div class="paybox_detail display_flex  justify-content_flex-justify align-items_center">
                    <div class="textalign_left">
                        <div class="line1">{{$t('order.desc2')}} </div>
                        <div class="line2">{{$t('personal.orderNo')}}：{{orderdetail.orderNo}}</div>
                        <div class="line3">{{$t('order.desc3')}} <span class="maincolor">{{timeleftfun}}</span> {{$t('order.desc4')}}</div>

                    </div>
                    <div>{{$t('order.pay_money')}}：<span class="payprice">¥ {{orderdetail.payTotal}}{{orderdetail.currency}}</span></div>
                </div>
                <!-- 支付宝 -->
                <div v-if="this.$route.query.type=='Alipay'" >
                    <div class="display_flex  justify-content_flex-center align-items_flex-end">
                        <div class="textalign_center">
                            <div class="padding_top_48">
                                <img src="http://p1.fishqc.net/FoNVuQbH-3yx9vhQIzCLpxNLWtna">
                            </div>
                            <div class="paymoney">¥ 29.7</div>
                            <div style="width:170px;height:170px;background:#eee;margin: 0 auto;"></div>
                            <div class="scan">支付宝扫一扫支付</div>

                        </div>
                        <div class="padding_left_44 padding_bottom_30">
                            <img src="http://p1.fishqc.net/FmRupBVX0yWcr0qGPKKPrkyOmcQv">
                        </div>
                    </div>
                </div>
                <!-- 微信 -->
                <div v-else>
                    <div class="display_flex  justify-content_flex-center align-items_flex-end">
                        <div class="textalign_center padding_bottom_30">
                            <div class="padding_top_48">
                                <img src="http://p1.fishqc.net/FjlKtvKqMIFQSaYxt_xQk8b69ZpY">
                            </div>
                            <div class="paymoney">¥ {{orderdetail.payTotal}}{{orderdetail.currency}}</div>
                            <!-- <div class="paycode" :style="{backgroundImage:'url('+code+')'}"></div> -->
                            <div >
                                <img :src="code" alt="" style="width:160px;height:160px;">
                            </div>
                            <div class="scan">{{$t('order.desc5')}}</div>

                        </div>
                        <div class="padding_left_132">
                            <img src="http://p1.fishqc.net/FuResdxaqFdFySYiNL2nmjpYN3eu">
                        </div>
                    </div>
                </div>
                <div class="padding_40">
                    
                    <div class="tips1">{{$t('order.desc6')}}</div>
                </div>
            </div>
        </div>
        <div class="modalClass" v-if="success"></div>
        <div class="successcontain" v-if="success">
            <div><img src="http://p1.fishqc.net/Flif7kyNxpRKkmsH4IO2fR5Ozcxx" alt="" class="vertical-middle"><span class="success">{{$t('order.desc7')}}</span></div>
            <div class="price">¥ {{orderdetail.payTotal}}</div>
            <div class="order_btn" @click="toOrder()">{{$t('order.checkorder')}}</div>
            <div class="success_desc"><span>{{$t('order.desc8')}} </span><span class="red">{{countseconds}}</span><span> {{$t('order.desc9')}}</span></div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";

.padding-32 {
    padding: 32px 0;
    box-sizing: border-box;
}
.padding_40{
    padding:0 40px;
    box-sizing: border-box;
}

// 购物车
.cart_suggesttitle {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 32px;
    text-align: left;
    padding: 32px 0;
    box-sizing: border-box;

}

.padding_left_394 {
    padding-left: 394px;
    box-sizing: border-box;
}

.padding_left_430 {
    padding-left: 430px;
    box-sizing: border-box;
}

.padding_left_72 {
    padding-left: 72px;
    box-sizing: border-box;
}

.padding_left_24 {
    padding-left: 24px;
    box-sizing: border-box;
}

.padding_left_16 {
    padding-left: 16px;
    box-sizing: border-box;
}

.padding_left_70 {
    padding-left: 70px;
    box-sizing: border-box;
}

.padding_left_32 {
    padding-left: 32px;
    box-sizing: border-box;
}
.padding_left_44{
    padding-left: 44px;
    box-sizing: border-box;
}

.padding_left_132{
    padding-left: 132px;
    box-sizing: border-box;
}

.padding_bottom_30{
    padding-bottom: 30px;
    box-sizing: border-box;
}

.padding_top_48{
    padding-top:48px;
    box-sizing: border-box;
}
.margin_top_32 {
    margin-top: 32px;
}

.margin_top_24 {
    margin-top: 24px;
}

.margin_top_88{
    margin-top: 88px;
}

.padding_top_32 {
    padding-top: 32px;
    box-sizing: border-box;
}

.padding_left_280 {
    padding-left: 280px;
    box-sizing: border-box;
}

.padding_left_162 {
    padding-left: 162px;
    box-sizing: border-box;
}

.padding_left_366 {
    padding-left: 366px;
    box-sizing: border-box;
}

.padding_left_958{
    padding-left: 958px;
    box-sizing: border-box;
}

.margin_top_40 {
    margin-top: 40px;
    box-sizing: border-box;
}

.margin_bottom_32{
    margin-bottom:32px;
}

.padding_right_16 {
    padding-right: 16px;
    box-sizing: border-box;
}
.padding_right_28{
    padding-right:28px;
    box-sizing: border-box;
}
// 
.paybox{
    width: 100%;
    border: 2px solid #00CF26;
    &.active{
        border-color:#00B8F1;
    }
    .paybox_detail{
        background: #F8FBFD;
        padding:20px 60px 18px 26px;
        box-sizing: border-box;
        .maincolor{
            color:#FF7467;
        }

        .line1{

            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #262633;
            line-height: 30px;
        }
        .line2{

            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #51515C;
            line-height: 32px;
        }

        .line3{

            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #51515C;
            line-height: 32px;
        }

        .payprice{

            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FF7467;
            line-height: 24px;
        }
    }
    
    .paymoney{
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FF7467;
        line-height: 24px;
        padding:12px 0 16px;
        box-sizing: border-box;
    }

    .scan{
        padding-top: 16px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #262633;
        line-height: 32px;
    }
    .tips{
        padding-top: 34px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 32px;
    }
    .tips1{
        padding-top: 14px;
        box-sizing: border-box;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FF7467;
        line-height: 24px;
        padding-bottom: 34px;
    }
}

.paycode{
    width:170px;
    height:170px;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;

}

.modalClass{
    width: 100%;
    height: 100%;
    background-color: rgba(38,38,51,.1);
    z-index: 9;
    position: fixed;
    top:0;
    left:0;
}

.successcontain{
    position: absolute;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
    width: 520px;
    height: 300px;
    padding-top: 32px;
    box-sizing: border-box;
    background-color: #fff;
    background-image: url('http://p1.fishqc.net/FqCzZWxlA2ULA8ZyN1V6qSKWd902');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    z-index: 9999;
    text-align: center;
    .success{
        font-size: 32px;
        font-family: 'PingFangSC-Medium';
        font-weight: 500;
        color: #60DEB4;
        line-height: 46px;
        vertical-align: middle;
        margin-left: 18px;
    }
    .price{
        font-size: 24px;
        font-family: 'PingFang SC';
        font-weight: 400;
        color: #262633;
        line-height: 29px;
        padding-top: 14px;
        box-sizing: border-box;
    }
    .order_btn{
        width: 144px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background: #60DEB4;
        color: #fff;
        margin:28px auto 0;
        cursor: pointer;
    }
    .success_desc{
        font-size: 14px;
        font-family: 'PingFang SC';
        font-weight: 400;
        color: #666666;
        line-height: 24px;
        padding-top: 32px;
        box-sizing: border-box;
        .red{
            color: #FF7467;
        }
    }
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import {myMixin} from '@/mixin/mixin.js'
import { queryOrderPayStatusApi,CartlistApi } from '@/api/api.js'
var countTimer
var countTimer1
export default {
    name: '',
    components: {
        banner,
    },
    mixins:[myMixin],
    data() {
        return {
            
            swiperOptions: {
                pagination: {
                    el: '.swiper-pagination1'
                },
                uniqueNavElements: false,

                // Some Swiper option/callback...
            },
            type:'WeChat',
            orderdetail:{
                orderNo:''
            },
            seconds:180,
            timeLeft:1799,
            success:false,
            countseconds:5,
            payorder:{
                WeChat:this.$t('order.wechat'),
                Alipay:this.$t('order.alipay')
            },
            currentlang:''
        }
    },
    computed: {
        swiper() {
            return this.$refs.order_report_Swiper.$swiper
        },
        code(){
            return 'https://'+this.orderdetail.qrcode
        },
        timeleftfun(){
            if(this.timeLeft){
                switch(this.currentlang){
                    case 'chs':
                        return parseInt(this.timeLeft/60) + '分钟'
                    break;
                    case 'cht':
                        return parseInt(this.timeLeft/60) + '分鐘'
                    break;
                    case 'eng':
                        return parseInt(this.timeLeft/60) + 'minutes'
                    break;
                }
                
            }
            
        }
    },
    mounted() {
        this.currentlang = window.localStorage.getItem("LOCALE")
        this.orderdetail = JSON.parse(window.sessionStorage.getItem('buystatus'));
        console.log(this.orderdetail)
        this.getorderstatus()
        this.getCartNum()
         document.addEventListener('visibilitychange',function(e){
            console.log(document.visibilityState);
            let state = document.visibilityState
            if(state == 'hidden'){
                countTimer = clearInterval(countTimer);
                console.log(document.visibilityState,'用户离开了');
            }
            if(state == 'visible'){
                console.log(document.visibilityState,'回来了');
            }
        });
    },
    methods: {
        getorderstatus(){
            var that = this
            countTimer = setInterval(function() {
                if(that.seconds == 0){
                    clearInterval(countTimer);
                }
                that.seconds--;
                that.getdetail()
            }, 1000);
            
        },
        getdetail(){
            var that = this;
            if(this.orderdetail.orderNo){
                queryOrderPayStatusApi({
                    orderNo:this.$route.query.orderNo
                }).then(res => {
                    this.timeLeft = res.data.lefttime
                    if (res.code == 200) {
                        // 支付成功,弹窗提示
                        this.success = true
                        
                        // 清空查询订单的倒计时
                        countTimer = clearInterval(countTimer);
                        // // 弹窗关闭的倒计时
                        // countTimer1 = setInterval(function() {
                        //     if(that.countseconds == 0){
                        //         // that.success = false
                        //          clearInterval(countTimer1);
                        //         return
                        //     }
                        //     that.countseconds--;
                        // }, 1000);
                        // 


                    } else {
                        
                        // countTimer = clearInterval(countTimer);
                        // this.toast(res.message)
                    }
                })
            }
            
        },
        toOrder(){
            this.$router.push({
                path:'/orderdetail',
                query:{
                    orderNo:this.$route.query.orderNo
                }
            })
        },
        getCartNum(){
            CartlistApi({}).then(res => {
                if (res.code == 200) {
                    // this.shoppingNUM = res.data.length
                    this.$store.commit('getcartsnum',res.data.length)
                    // console.log(this.shoppingNUM)
                } else if(res.code == 204) {
                    

                }else{
                    // this.toast(res.message)
                }
            })
        }
    }
}


</script>